import styled from 'styled-components';

import styles from '../../styles/base_components/MultiSelect.module.scss';

const Wrapper = styled.div`
  .${styles.input} {
    input {
      ${props => props.error && `
      border: 1px solid ${props.theme.jellyBean};
      box-shadow: 0 0 5px ${props.theme.jellyBean};
    `}
    }

    img {
      ${props => props.showList && `
      transform: rotate(180deg);
    `}
    }
  }

  .${styles.list} {
    display: ${props => props.showList ? 'block' : 'none'};
    ${props => props.error && `
      border: 1px solid ${props.theme.jellyBean};
      box-shadow: 0 0 5px ${props.theme.jellyBean};
    `}
  }
`;

export default Wrapper;